<template>
  <div class="hs-wrap">
    <div class="hs-grid">
      <span
        v-for="(slot, idx) in slots"
        :key="idx"
        class="hs-cell"
        :class="`hs-cell--${slot.status || 'empty'}`"
        :style="{ '--i': idx }"
        :title="slot.label || ''"
      ></span>
    </div>
    <div v-if="showLegend" class="hs-legend">
      <span class="hs-legend__item"><span class="hs-cell hs-cell--static hs-cell--ok"></span> OK</span>
      <span class="hs-legend__item"><span class="hs-cell hs-cell--static hs-cell--slow"></span> Lento</span>
      <span class="hs-legend__item"><span class="hs-cell hs-cell--static hs-cell--warn"></span> Alerta</span>
      <span class="hs-legend__item"><span class="hs-cell hs-cell--static hs-cell--down"></span> Caído</span>
      <span class="hs-legend__item"><span class="hs-cell hs-cell--static hs-cell--empty"></span> Sin datos</span>
    </div>
  </div>
</template>

<script setup>
// GitHub-contribution-style health strip. Each slot: { status, label }
// status: 'ok' | 'slow' | 'warn' | 'down' | 'empty'
// Colors are themeable: the host page can override the --hs-* variables.
defineProps({
  slots: { type: Array, default: () => [] },
  showLegend: { type: Boolean, default: false },
});
</script>

<style scoped>
.hs-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
}
.hs-cell {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 2px;
  background: var(--hs-empty, #1c2333);
  flex: 0 0 auto;
  animation: hs-pop 0.35s ease-out backwards;
  animation-delay: calc(var(--i, 0) * 1.5ms);
  transition: transform 0.15s ease, background-color 0.3s ease;
}
.hs-cell:hover {
  transform: scale(1.6);
}
.hs-cell--static {
  animation: none;
}
@keyframes hs-pop {
  from {
    opacity: 0;
    transform: scale(0.3);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
.hs-cell--ok { background: var(--hs-ok, #39d353); }
.hs-cell--slow { background: var(--hs-slow, #006d32); }
.hs-cell--warn { background: var(--hs-warn, #d29922); }
.hs-cell--down { background: var(--hs-down, #f85149); }
.hs-cell--empty { background: var(--hs-empty, #1c2333); }
.hs-legend {
  display: flex;
  gap: 14px;
  margin-top: 8px;
  font-size: 11px;
  color: var(--hs-legend, #7d8590);
  align-items: center;
}
.hs-legend__item {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}
@media (prefers-reduced-motion: reduce) {
  .hs-cell { animation: none; transition: none; }
}
</style>
